export function FirstOrNull(obj: any) {
  if (obj === null || obj === undefined) return null;

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      return obj[i];
    }
  }
  return null;
}

export function RoundTo(n: any, digits: number): number {
  if (n === null) return n;
  if (n === undefined) return n;

  var negative = false;
  if (digits === undefined) {
    digits = 0;
  }
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(digits);
  if (negative) {
    n = (n * -1).toFixed(digits);
  }
  return n * 1;
}

//Round up to the nearest multiple
export function RoundUp(num: number, multiple: number): number {
  if (num === 0) return 0;
  if (multiple === 0) return num;

  let remainder: number = num % multiple;

  if (remainder === 0) return num;

  let result: number = num + multiple - remainder;
  return result;
}

export function GetDayOfWeekFromRoute(route: string): string {
  if (route.length >= 5) {
    let datenum = route.substring(3, 5);
    let num = Number(datenum);
    if (num == 0) return 'Sunday';
    if (num == 1) return 'Monday';
    if (num == 2) return 'Tuesday';
    if (num == 3) return 'Wednesday';
    if (num == 4) return 'Thursday';
    if (num == 5) return 'Friday';
    if (num == 6) return 'Saturday';
  }

  return '';
}

export function GetDayOfWeekFromDate(date: string): string {
  if (!date) return '';
  let ds = date.toString();
  if (ds.indexOf('T') > 0) {
    ds = date.substring(0, ds.indexOf('T'));
  }
  let d = new Date(ds);
  d.setDate(d.getDate() + 1);

  let num = d.getDay();
  if (num == 0) return 'Sunday';
  if (num == 1) return 'Monday';
  if (num == 2) return 'Tuesday';
  if (num == 3) return 'Wednesday';
  if (num == 4) return 'Thursday';
  if (num == 5) return 'Friday';
  if (num == 6) return 'Saturday';
}

export function GetOrderTypeFullName(orderType: string): string {
  if (orderType === 'W') return 'Warehouse';
  if (orderType === 'D') return 'Direct';
  if (orderType === 'P') return 'Plant';
  return '';
}

//Creates random password with uppercase, lowercase, numbers, and symbols
export function GenerateRandomPassword(length: number) {
  const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*';
  const allCharacters = uppercaseLetters + lowercaseLetters + numbers + symbols;

  let password = '';
  const randomUppercase = uppercaseLetters.charAt(Math.floor(Math.random() * uppercaseLetters.length));
  const randomLowercase = lowercaseLetters.charAt(Math.floor(Math.random() * lowercaseLetters.length));
  const randomSymbol = symbols.charAt(Math.floor(Math.random() * symbols.length));
  const randomNumber = numbers.charAt(Math.floor(Math.random() * numbers.length));

  password += randomUppercase + randomLowercase + randomSymbol + randomNumber;

  for (let i = 4; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * allCharacters.length);
    password += allCharacters.charAt(randomIndex);
  }

  // Shuffle the characters in the password string
  password = password.split('').sort(() => Math.random() - 0.5).join('');

  return password;
}
